import React from "react"

import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {DashboardTemplateConfig} from "../../../../../../core/gd-modules/dashboard/templates/templates-custom"
import DashboardTemplatePreview from "../template-preview/dashboard-template"
import {
    dashboardTemplatesProject,
    emptyProjectDashboardTemplate
} from "../../../../../../core/gd-modules/dashboard/templates/project/goodday/templates-project"
import {BreadcrumbElement} from "../../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"
import {QuickAddBreadcrumbElement} from "../../../../@types"
import QuickAdd_BreadcrumbNavigation from "../../../../layout/page-title/form-title-breadcrumb"
import Template from "../../../../../../core/model2/template/template";
import NewDashboardMain from "../../new-dasshboard-main";
import QuickAdd_Group from "../../../../common/group";

type Props = {
    className?  : string,
    app         : NewDashboardMain
    initParams  : any
}

export default function QuickAdd_NewDashboard_SelectProjectDashboardTemplate(props: Props) {

    const myTemplates          : Template[]    = gd.session.templates.projectDashboards
    const shouldShowMyTemplates: boolean       = myTemplates?.length > 0

    const gdTemplates = _.filter(dashboardTemplatesProject, (template: DashboardTemplateConfig) => {
        return template.templateId !== 'project-empty'
    })

    const onSelectGdTemplate = (template:DashboardTemplateConfig) => {
        props.app.setState({
            gdTemplate : template
        })
    }

    const onSelectMyTemplate = (template:Template) => {
        props.app.setState({
            myTemplate : template
        })
    }

    const breadcrumbItems: BreadcrumbElement[] = [
        QuickAddBreadcrumbElement.DASHBOARD,
        QuickAddBreadcrumbElement.PROJECT_DASHBOARD
    ]


    return (
        <div className="new-main dashboard">

            <QuickAdd_BreadcrumbNavigation breadcrumbItems={breadcrumbItems}/>

            <VScroll className="quick-add-content p-t-25">

                <QuickAdd_Group className="m-b-20">
                    <DashboardTemplatePreview
                        template    = {emptyProjectDashboardTemplate}
                        onClick     = {onSelectGdTemplate}
                        imgClassName= "w-35 h-35"

                    />
                </QuickAdd_Group>


                {shouldShowMyTemplates &&
                    <QuickAdd_Group title="My Templates" className="m-b-20">

                        {_.map(myTemplates, (template,key) => (
                            <DashboardTemplatePreview
                                key         = {key}
                                template    = {template}
                                onClick     = {onSelectMyTemplate}
                                imgClassName= "w-90 h-60 thumbnail"
                            />
                        ))}
                    </QuickAdd_Group>
                }

                <QuickAdd_Group title="GoodDay Templates" className="m-b-20">

                    {_.map(gdTemplates, (dashboardTemplate, key) => (
                        <DashboardTemplatePreview
                            key         = {key}
                            template    = {dashboardTemplate}
                            onClick     = {onSelectGdTemplate}
                            imgClassName= "m-l-10 m-t-6 w-175 h-80"
                        />
                    ))}
                </QuickAdd_Group>


            </VScroll>
        </div>
    )

}
